import { faPaperPlane } from '@fortawesome/free-solid-svg-icons'

import Icon from './common-parts/Icon'

export default function PaperPlaneIcon(props) {
  return (
      <Icon
        size="2x"
        transform="down-3"
        {...props}
        icon={faPaperPlane}
      />
  );
}
